export type Paginate = {
  sort: string
  sortOrder: -1 | 1
  page: number
  perPage: number
}

export type PaginatedResponse = true
export const paginated: PaginatedResponse = true
